var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"agInvalidPage"}},[_c('div',{attrs:{"id":"agInvalidPage-invalid"}},[_c('fa',{attrs:{"icon":"heart-broken"}}),_vm._v(" "),_c('div',[_vm._v("Invalid license. Please contact ActiveG")]),_vm._v(" "),_c('b-button',{staticClass:"agTextButton",on:{"click":_vm.refreshButton_click}},[_vm._v("Refresh")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09a2bfad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvalidPage.vue
// module id = null
// module chunks = 